import { PrimaryContractorUser } from "../../../types/models/ContractorUser";
import ContractorUserName from "./ContractorUserName";
import { contractorUserApi } from "../../../apis/ContractorUser.api.ts";
import {linkPath as linkPathParent} from "../../../../timber/components/contractor/ContractorDetail/ContractorLink";    
import * as React from 'react';
import { NavLink } from "react-router";
import Link, { LinkProps } from '@mui/material/Link';
import {useDispatch} from "react-redux";
import {ID} from "../../../../types/global";
import {ReactElement} from "react";

interface LinkRouterProps extends LinkProps {
    to: string;
    replace?: boolean;
}

type IFormProps = {
    icon: ReactElement,
    id: ID;

};

function LinkRouter(props: LinkRouterProps) {
    return <Link {...props} component={NavLink as any} />;
}

export const linkPath = async (dispatch, id) => {
    const {data} = await dispatch(contractorUserApi.endpoints.getContractorUser.initiate(PrimaryContractorUser.fromId(id)))
    const prefix = await linkPathParent(dispatch, data.contractorId)
    return `${prefix}/contractor-users/${PrimaryContractorUser.fromId(id).toPath()}`
}

const ContractorUserLink: React.FC<IFormProps> = ({id, icon}) => {
    
    const dispatch = useDispatch()
    const [link, setLink] = React.useState('')
    
    React.useEffect(() => {
        linkPath(dispatch, id)
            .then(setLink)
    }, [id])

    if (id)
        if (link)
            return (
                <LinkRouter to={ `/dashboard${link}` } viewTransition={true}>
                    <ContractorUserName id={id}/> { icon && icon }
                </LinkRouter>
            )
        else
            return (<ContractorUserName id={id}/>)
    else
        return undefined
}
export default ContractorUserLink;
